import React, { useState, useCallback, useEffect, useRef } from 'react';
import {
    Modal,
    Button,
    Box,
    IconButton,
    Grid,
    TextField,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Card,
    CardMedia,
    CardContent,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ChromePicker } from 'react-color';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import licenseApi from '../../../../../../services/managelicense';
import fileuploadApi from '../../../../../../services/managelicense';
import headerApi from '../../../../../../services/managelicense';
import getlicensebusinessuuidApi from '../../../../../../services/managelicense';
import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../../../../../redux/loader/actions';
import { showSnackbar } from '../../../../../../redux/snackbar/actions';
import { makeStyles } from '@mui/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { subDays } from 'date-fns';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../../../../utils';
import BillPreviewFront from './bill_preview/front';
import EditBill from '../../license_details_accordion/editbillpreview/editPrint';
import BillPreviewBack from './bill_preview/back';
import BillImg1 from '../../../../../../assets/img/bill1.png';
import BillImg2 from '../../../../../../assets/img/bill2.png';
import BillImg3 from '../../../../../../assets/img/bill3.png';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles({
    animatedButton: {
        background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
        color: '#fff',
        padding: '10px 30px',
        fontSize: '16px',
        fontWeight: 'bold',
        textTransform: 'none',
        borderRadius: '5px',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)',
            background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)'
        }
    },
    underline: {
        display: 'inline-block',
        borderBottom: '2px solid #000',
        paddingBottom: '0.5px !important'
    },
    '@media print': {
        '@page': {
            size: 'A4 landscape',
            margin: '0'
        },
        body: {
            margin: '0',
            padding: '0'
        }
    }
});

const LicenseModal = ({
    open,
    onClose,
    license,
    licenses,
    getLicensebusinessId,
    licenseuuid,
    setLicenseUuid,
    businesssid,
    loanNumberType
}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { productid, busUid, businesssuuid } = useParams();
    const proid = getDecryptedCookie('proid') || productid;
    const [pickerVisible, setPickerVisible] = useState(false);
    const [validTill, setValidTill] = useState(null);
    const [loanStartDate, setLoanStartDate] = useState(null);
    const [previousLoanDateFrom, setPreviousLoanDateFrom] = useState(null);
    const [previousLoanDateTo, setPreviousLoanDateTo] = useState(null);
    const [billPrintColor, setBillPrintColor] = useState('#000000');
    const [fontColor, setFontColor] = useState();
    const [language, setLanguage] = useState('ta');

    const [licensePrintModalBack, setLicensePrintModalBack] = useState(false);
    const handleOpen = () => {
        setLicensePrintModal(true);
    };
    const handleOpenFront = () => {
        setLicensePrintModal(true);
    };
    const handleBackOpen = () => {
        setLicensePrintModalBack(true);
    };
    const handleClose = () => setLicensePrintModal(false);
    const handleBackClose = () => setLicensePrintModalBack(false);
    const [headerImages, setHeaderImages] = useState([]);

    const [licensePrintModal, setLicensePrintModal] = useState(false);
    const [paperbillType, setPaperbillType] = useState(false);

    const [selectedImages, setSelectedImages] = useState([]);

    const [licensecopy, setLicenseCopy] = useState(null);

    const [selectedOption, setSelectedOption] = useState('');

    const [businessuuid, setBusinessuuid] = useState([]);

    const handleColorChangeComplete = (color) => {
        setBillPrintColor(color.hex);

        formik.setFieldValue('billprint', color.hex);
        setPickerVisible(false);
    };

    const handleToggleColorPicker = () => {
        setPickerVisible(!pickerVisible);
    };
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const dispatch = useDispatch();

    const billFileId = selectedImages.length > 0 ? selectedImages[0].file_uuid : '';
    const [showPicker, setShowPicker] = useState(true);

    const handleTogglePicker = () => {
        setShowPicker(!showPicker);
    };

    const [fileName, setFileName] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    useEffect(() => {
        setUploadedImage(null);
    }, [open]);

    const applyColorToImage = (imageSrc, color) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = imageSrc;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height;

            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            const colorRGB = hexToRgb(color);

            for (let i = 0; i < data.length; i += 4) {
                data[i] = colorRGB.r;
                data[i + 1] = colorRGB.g;
                data[i + 2] = colorRGB.b;
            }

            ctx.putImageData(imageData, 0, 0);

            canvas.toBlob((blob) => {
                if (blob) {
                    const modifiedImageUrl = URL.createObjectURL(blob);
                    setUploadedImage(modifiedImageUrl);
                    const formData = new FormData();
                    formData.append('files', blob, 'colored-image.png');
                    formData.append('business_id', businessid);
                    fileUploadBill(formData);
                }
            }, 'image/png');
        };
    };

    const hexToRgb = (hex) => {
        hex = hex.replace(/^#/, '');
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return { r, g, b };
    };

    const handleFileUploadWithBlob = (imageBlob) => {
        const formData = new FormData();
        formData.append('files', imageBlob, 'colored-image.png');
        formData.append('business_id', businessid);
    };

    const fileUploadBill = useCallback(
        async (formData) => {
            if (isUploading) return;

            dispatch(showLoader());
            try {
                const res = await fileuploadApi.fileUpload(formData);
                if (res.data && res.data.data && res.data.data[0].uuid) {
                    const uploadedImageUuid = res.data.data[0].uuid;
                    const uploadedImageUrl = res.data.data[0].public_url;
                    setEncryptedCookie('img', res.data.data[0].public_url);
                    setUploadedImage(uploadedImageUrl);
                    formik.setFieldValue('headerimage', uploadedImageUuid);

                    setIsUploading(false);
                    dispatch(hideLoader());

                    dispatch(
                        showSnackbar({
                            message: 'File uploaded successfully',
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            },
                            variant: 'success'
                        })
                    );
                }
            } catch (error) {
                console.error('Error:', error);
                setIsUploading(false);
                dispatch(hideLoader());
            }
        },
        [isUploading]
    );

    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const [imagePreviews, setImagePreviews] = useState([
        { url: BillImg1, name: 'bill1.png' },
        { url: BillImg2, name: 'bill2.png' },
        { url: BillImg3, name: 'bill3.png' }
    ]);
    const handleImageClick = (index) => {
        setSelectedImageIndex(index);
        handleFileChange(index);
    };

    const handleFileChange = (index) => {
        const selectedImage = imagePreviews[index];
        if (!selectedImage) {
            console.error('No image found at index:', index);
            return;
        }

        const imageUrl = selectedImage.url;
        const imageName = selectedImage.name;

        fetch(imageUrl)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], imageName, { type: blob.type });
                processFile(file);
            })
            .catch((error) => {
                console.error('Error fetching image:', error);
            });
    };

    const processFile = (file) => {
        if (file) {
            setFileName(file.name);

            const reader = new FileReader();
            reader.onloadend = () => {
                const uploadedImageUrl = reader.result;
                setUploadedImage(uploadedImageUrl);

                if (fontColor && !isUploading) {
                    applyColorToImage(uploadedImageUrl, fontColor);
                } else {
                    const formData = new FormData();
                    formData.append('files', file);
                    formData.append('business_id', businessid);

                    fileUploadBill(formData);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleFileCustomChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);

            const reader = new FileReader();
            reader.onloadend = () => {
                const uploadedImageUrl = reader.result;
                setUploadedImage(uploadedImageUrl);

                if (fontColor && !isUploading) {
                    applyColorToImage(uploadedImageUrl, fontColor);
                } else {
                    const formData = new FormData();
                    formData.append('files', file);
                    formData.append('business_id', businessid);
                    fileUploadBill(formData);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleColorChange = (event) => {
        const newColor = event.target.value;
        setFontColor(newColor);
        if (uploadedImage) {
            applyColorToImage(uploadedImage, newColor);
        }
    };

    const fileUpload = useCallback(async (formData) => {
        dispatch(showLoader());
        try {
            const res = await fileuploadApi.fileUpload(formData);
            if (res.data && res.data.data && res.data.data[0].uuid) {
                setLicenseCopy(res.data.data[0].uuid);
                dispatch(hideLoader());
                dispatch(
                    showSnackbar({
                        message: 'File uploaded successfully',
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        variant: 'success'
                    })
                );
            }
        } catch (error) {
            console.error('Error:', error);
            dispatch(hideLoader());
        }
    }, []);

    const getHeaderImages = useCallback((proid) => {
        const onSuccess = (res) => {
            if (res.data.status === true) {
                setHeaderImages(res.data.data.data);
            } else {
                console.error('Failed to fetch images');
            }
        };

        const onFailure = (err) => {
            console.error('Failed to fetch data', err);
            setHeaderImages([]);
        };

        headerApi.headerImage(proid).then(onSuccess).catch(onFailure);
    }, []);

    useEffect(() => {
        getHeaderImages(proid);
    }, [getHeaderImages]);

    const businessid = getDecryptedCookie('bi') || busUid;
    const business_uuid = getDecryptedCookie('buslap') || businessuuid;
    const getbusinessuuid = useCallback((proid, business_uuid) => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res.data.status) {
                setBusinessuuid(res.data.data);
            }
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch data', err);
            setBusinessuuid([]);
        };

        getlicensebusinessuuidApi.getbusinessId(proid, business_uuid).then(onSuccess).catch(onFailure);
    }, []);

    useEffect(() => {
        getbusinessuuid(proid, business_uuid);
    }, [getbusinessuuid]);

    const isFormValid = () => {
        const isPreviousLoanValid =
            formik.values.previousloandaterangefrom &&
            formik.values.previousloandaterangeto &&
            formik.values.previousloannumberfrom?.trim() &&
            formik.values.previousloannumberto?.trim();

        const isHeaderImageUploaded = Boolean(uploadedImage);

        return (
            formik.values.licensealiasname?.trim() &&
            formik.values.licensevalidatill &&
            (formik.values.previousloandaterangefrom ? isPreviousLoanValid : true) &&
            formik.values.billprint?.trim() &&
            formik.values.billtype?.trim() &&
            isHeaderImageUploaded
        );
    };

    const handleSelectImage = async (uuid, option) => {
        const selectedImage = headerImages.find((img) => img.file_uuid === uuid);
        if (!selectedImage) {
            console.error('No image found for the given UUID');
            return;
        }

        setSelectedOption((prevOption) => (prevOption === option ? '' : option));

        try {
            const binaryData = await convertImageToBinary(selectedImage.actual_path);
            const base64String = arrayBufferToBase64(binaryData);

            setSelectedImages([{ ...selectedImage, binaryData, base64String }]);
            formik.setFieldValue('headerimage', base64String);
        } catch (error) {
            console.error('Error processing image:', error);
        }
    };

    const convertImageToBinary = async (imageUrl) => {
        try {
            const response = await fetch(imageUrl, {
                mode: 'cors'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const blob = await response.blob();

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = (error) => {
                    console.error('FileReader error:', error);
                    reject(error);
                };
                reader.readAsArrayBuffer(blob);
            });
        } catch (error) {
            console.error('Error fetching image:', error);
            throw error;
        }
    };
    const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    };

    const formik = useFormik({
        initialValues: {
            licensealiasname: '',
            licensevalidatill: null,
            previousloandaterangefrom: null,
            previousloandaterangeto: null,
            previousloannumberfrom: '',
            previousloannumberto: '',
            billprint: '',
            billtype: 'general',
            businesslogo: null,
            headerimage: null,
            isGoldItemPrefix: false,
            isSilverItemPrefix: false,
            isBacksideTableAllowed: false
        },

        validationSchema: Yup.object({
            licensealiasname: Yup.string()
                .min(3, 'License Alias must be at least 3 characters long')
                .max(5, 'License Alias cannot exceed 5 characters')
                .required('License Alias Name required'),

            // licensevalidatill: Yup.date().required(
            //   "License valid till date is required"
            // )
            //   .min(new Date(), "License valid till date must be in the future"),
            licensevalidatill: Yup.date()
                .typeError('Invalid date')
                .required('License valid till date is required')
                .min(
                    new Date(new Date().setHours(0, 0, 0, 0)),
                    'License valid till date must be today or in the future'
                ),

            billprint: Yup.string()
                .required('Bill print color is required')
                .matches(/^#[0-9A-F]{6}$/i, 'Invalid color format'),

            billtype: Yup.string().required('Bill type is required'),

            businesslogo: Yup.mixed()
                .nullable()
                .test('fileSize', 'File is too large', (value) => {
                    return value ? value.size <= 5 * 1024 * 1024 : true; // Only validate size if there's a file
                })
                .test('fileType', 'Only PNG, JPEG, and PDF files are allowed', (value) => {
                    return !value || ['image/png', 'image/jpeg', 'application/pdf'].includes(value.type);
                }),

            headerimage: Yup.mixed()
                .required('Bill header image is required')
                .test('imageSelected', 'Please select a valid image', (value) => {
                    const isValidImage =
                        value !== null && value !== undefined && (typeof value === 'string' || value instanceof Blob);
                    return isValidImage;
                }),

            previousloandaterangefrom: Yup.date()
                .nullable()
                .typeError('Invalid date')
                .max(subDays(new Date(), 1), 'Date cannot be today or a future date'),

            previousloandaterangeto: Yup.date()
                .nullable()
                .typeError('Invalid date')
                // .required("Previous Loan Date Range To is required")
                .max(subDays(new Date(), 1), 'Date cannot be today or a future date')
                .test('is-required-if-from-selected', 'Previous Loan Date Range To is required', function (value) {
                    const { previousloandaterangefrom } = this.parent;
                    if (previousloandaterangefrom && !value) {
                        return false;
                    }
                    return true;
                })
                .test('min-date', "The 'To' date cannot be before the 'From' date", function (value) {
                    const { previousloandaterangefrom } = this.parent;
                    if (previousloandaterangefrom && value && value < previousloandaterangefrom) {
                        return false;
                    }
                    return true;
                }),

            previousloannumberfrom: Yup.string()
                .nullable()
                .matches(
                    /^[A-Za-z]?\d{5}$/,
                    'Previous Loan Number From must be in the format of either A00001-Z10000 or 00001-10000'
                )
                .test(
                    'within-range-from',
                    'Previous Loan Number From must be within the valid range.',
                    function (value) {
                        if (!value) return true;
                        const numericValue = parseInt(value.replace(/[A-Za-z]/, ''), 10);
                        if (value.match(/^[A-Za-z]/)) {
                            const prefix = value[0].toUpperCase();
                            const numPart = parseInt(value.slice(1), 10);
                            if (numPart < 1 || numPart > 10000 || prefix < 'A' || prefix > 'Z') {
                                return false;
                            }
                        } else {
                            if (numericValue < 1 || numericValue > 10000) {
                                return false;
                            }
                        }

                        return true;
                    }
                )
                .test('is-required-if-from-selected', 'Previous Loan Number From is required', function (value) {
                    const { previousloandaterangefrom } = this.parent;
                    if (previousloandaterangefrom && !value) {
                        return false;
                    }
                    return true;
                }),

            previousloannumberto: Yup.string()
                .nullable()
                .matches(
                    /^[A-Za-z]?\d{5}$/,
                    'Previous Loan Number To must be in the format of either A00001-Z10000 or 00001-10000'
                )
                .test('is-required-if-from-selected', 'Previous Loan Number To is required', function (value) {
                    const { previousloandaterangefrom } = this.parent;
                    if (previousloandaterangefrom && !value) {
                        return false;
                    }
                    return true;
                })
                .test(
                    'not-equal-to-from',
                    'Previous Loan Number To cannot be the same as Previous Loan Number From',
                    function (value) {
                        const { previousloannumberfrom } = this.parent;
                        if (previousloannumberfrom && value === previousloannumberfrom) {
                            return false;
                        }
                        return true;
                    }
                )
                .test(
                    'greater-than-from',
                    'Previous Loan Number To must be greater than Previous Loan Number From',
                    function (value) {
                        const { previousloannumberfrom } = this.parent;

                        if (previousloannumberfrom && value) {
                            const fromIsAlpha = /^[A-Za-z]/.test(previousloannumberfrom);
                            const toIsAlpha = /^[A-Za-z]/.test(value);

                            const fromValue = parseInt(previousloannumberfrom.replace(/[A-Za-z]/, ''), 10);
                            const toValue = parseInt(value.replace(/[A-Za-z]/, ''), 10);

                            if (!fromIsAlpha && toIsAlpha) {
                                return true;
                            }

                            if (fromIsAlpha && !toIsAlpha) {
                                return false;
                            }

                            if (fromIsAlpha && toIsAlpha) {
                                const fromPrefix = previousloannumberfrom[0].toUpperCase();
                                const toPrefix = value[0].toUpperCase();

                                if (fromPrefix > toPrefix) {
                                    return false;
                                }
                                if (fromPrefix === toPrefix && fromValue >= toValue) {
                                    return false;
                                }
                            } else {
                                if (fromValue >= toValue) {
                                    return false;
                                }
                            }
                        }
                        return true;
                    }
                )

                .test('max-10000', 'Previous Loan Number To cannot exceed 10000', function (value) {
                    if (value) {
                        const numericValue = parseInt(value.replace(/[A-Za-z]/, ''), 10);
                        return numericValue <= 10000;
                    }
                    return true;
                })
        }),

        onSubmit: (values) => {
            if (!formik.isValid) {
                return;
            }
            const data = {
                ...values,
                license_copy: licensecopy
            };
            manageLicense(values);
            formik.resetForm();
            setSelectedImages([]);
            setSelectedOption('');
        }
    });

    useEffect(() => {
        if (!open) {
            formik.resetForm();
        }
    }, [open]);

    const [front, setFront] = useState(false);
    useEffect(() => {
        removeCookie('lic');
        removeCookie('img');
        removeCookie('col');
    }, []);

    const [billLicenceID, setBillLicenceID] = useState('');
    const manageLicense = useCallback(
        (licenseData, index) => {
            dispatch(showLoader());
            const headerImageToSend = formik.values.headerimage ? formik.values.headerimage : uploadedImage;
            const data = {
                license_number: license.number,
                license_name: license.name,
                license_alias_name: licenseData.licensealiasname,
                license_valid_till: formatDate(licenseData.licensevalidatill),
                previous_loan_date_range_from: licenseData.previousloandaterangefrom
                    ? formatDate(licenseData.previousloandaterangefrom)
                    : null,
                previous_loan_date_range_to: licenseData.previousloandaterangeto
                    ? formatDate(licenseData.previousloandaterangeto)
                    : null,
                previous_loan_number_from: licenseData.previousloannumberfrom
                    ? licenseData.previousloannumberfrom
                    : null,
                previous_loan_number_to: licenseData.previousloannumberto ? licenseData.previousloannumberto : null,
                bill_print_font_color: licenseData.billprint,
                bill_type: licenseData.billtype,
                license_copy: licensecopy,
                business_id: businessid,
                bill_file_id: headerImageToSend,
                is_backside_table_allowed: licenseData.isBacksideTableAllowed,
                is_glod_item_pefix: licenseData.isGoldItemPrefix,
                is_silver_item_pefix: licenseData.isSilverItemPrefix
            };
            setEncryptedCookie('col', licenseData?.billprint);
            licenseApi
                .manageLicense(proid, data)
                .then((response) => {
                    dispatch(hideLoader());
                    dispatch(
                        showSnackbar({
                            message: 'License Created Successfully',
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            },
                            variant: 'success'
                        })
                    );
                    setEncryptedCookie('lic', response?.data?.data?.data?.uuid);
                    setBillLicenceID(response?.data?.data?.data?.uuid);
                    console.log('first', response?.data?.data);
                    setPaperbillType(licenseData.billtype);
                    setLicensePrintModal(true);
                    setFront(true);
                    formik.resetForm();
                    getLicensebusinessId(proid, businessid);

                    // setUploadedImage(null);
                    if (licensePrintModal) {
                        onClose();
                    }
                })
                .catch((error) => {
                    dispatch(hideLoader());
                    dispatch(
                        showSnackbar({
                            message: error.response.data.res.message,
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            },
                            variant: 'error'
                        })
                    );
                    console.error('Error:', error);
                });
        },
        [licenses, selectedImages, formik, uploadedImage]
    );

    const firstCanvasRef = useRef(null);
    const secondCanvasRef = useRef(null);
    const [triggerEffect, setTriggerEffect] = useState(false);
    const tempImg = selectedImages && selectedImages.length > 0 ? selectedImages[0]?.actual_path : uploadedImage;

    const changeImageColor = (canvasRef) => {
        if (!fontColor || !canvasRef.current || !tempImg) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.src = tempImg;

        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            ctx.globalCompositeOperation = 'source-in';
            ctx.fillStyle = fontColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        };

        img.onerror = () => {
            console.error('Failed to load image:', img.src);
        };
    };

    useEffect(() => {
        if (licensePrintModal) {
            setTriggerEffect(true);
            const timer = setTimeout(() => {
                setTriggerEffect(false);
            }, 0);
            return () => clearTimeout(timer);
        }
    }, [licensePrintModal]);

    useEffect(() => {
        changeImageColor(firstCanvasRef);
        changeImageColor(secondCanvasRef);
    }, [triggerEffect]);

    if (!open) return null;

    const textColorStyle = { color: formik.values.billprint };
    console.log('LicenseModal loanNumberType:', loanNumberType);

    return (
        <Modal
            open={open}
            onClose={() => {
                onClose();
                setUploadedImage(null);
            }}
            aria-labelledby='new-license-modal'
            aria-describedby='modal-to-show-new-license'
        >
            <Box
                sx={{
                    padding: 4,
                    width: '100%',
                    maxWidth: 950,
                    margin: 'auto',
                    backgroundColor: 'white',
                    borderRadius: 2,
                    position: 'absolute',
                    top: '45%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    boxShadow: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    maxHeight: '85vh',
                    paddingBottom: 2,
                    overflowY: 'auto',
                    overflowX: 'auto',
                    width: { xs: '70%', sm: '90%', md: '90%', lg: '90%' },
                    maxHeight: '85vh',
                    paddingBottom: 2
                }}
            >
                <IconButton
                    onClick={() => {
                        formik.resetForm();
                        onClose();
                    }}
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 0,
                        color: 'gray'
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Grid container spacing={2} sx={{ marginTop: { xs: '587px', sm: '32px', md: '32px' } }}>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextField label='License Number' value={license?.number || ''} fullWidth disabled />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextField label='License Name' value={license?.name || ''} fullWidth disabled />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextField
                            label='License Alias Name'
                            name='licensealiasname'
                            value={formik.values.licensealiasname}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            fullWidth
                            error={formik.touched.licensealiasname && Boolean(formik.errors.licensealiasname)}
                            helperText={formik.touched.licensealiasname && formik.errors.licensealiasname}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4} md={4}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                            }}
                        >
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                format="dd/MM/yyyy"
                  label="License Valid Till"
                  value={formik.values.licensevalidatill}
                  onChange={(date) => {
                    formik.setFieldValue("licensevalidatill", date);
                    formik.setFieldTouched("licensevalidatill", true);
                    formik.validateField("licensevalidatill");
                  }}
                  minDate={new Date()}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      onBlur={(e) => {
                        formik.setFieldTouched("licensevalidatill", true);
                        // formik.handleBlur(e);
                        formik.validateField("licensevalidatill");
                      }}
                      error={
                        formik.touched.licensevalidatill &&
                        Boolean(formik.errors.licensevalidatill)
                      }
                      helperText={
                        formik.touched.licensevalidatill &&
                        formik.errors.licensevalidatill
                      }
                    />
                  )}
                />
                {formik.touched.licensevalidatill &&
                  formik.errors.licensevalidatill && (
                    <Typography sx={{ color: "red", fontSize: "13px" }}>
                      {formik.errors.licensevalidatill}
                    </Typography>
                  )}
              </LocalizationProvider> */}
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    format='dd/MM/yyyy'
                                    label='License Valid Till'
                                    value={formik.values.licensevalidatill}
                                    onChange={(date) => {
                                        console.log('Selected Date:', date);
                                        if (date) {
                                            formik.setFieldValue('licensevalidatill', date);
                                            formik.setFieldTouched('licensevalidatill', true, false);
                                            formik.validateField('licensevalidatill');
                                        }
                                    }}
                                    minDate={new Date()} // Ensures UI prevents past dates
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth
                                            onBlur={() => {
                                                formik.setFieldTouched('licensevalidatill', true, false);
                                                formik.validateField('licensevalidatill');
                                            }}
                                            error={
                                                formik.touched.licensevalidatill &&
                                                Boolean(formik.errors.licensevalidatill)
                                            }
                                            helperText={
                                                formik.touched.licensevalidatill && formik.errors.licensevalidatill
                                            }
                                        />
                                    )}
                                />
                                {formik.touched.licensevalidatill && formik.errors.licensevalidatill && (
                                    <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                        {formik.errors.licensevalidatill}
                                    </Typography>
                                )}
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                        <TextField
                            type='file'
                            label='License Copy'
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            onChange={(event) => {
                                const file = event.currentTarget.files[0];
                                if (file) {
                                    const MAX_SIZE = 3 * 1024 * 1024;
                                    if (file.size > MAX_SIZE) {
                                        formik.setFieldValue('businesslogo', null);
                                        alert('File size should not exceed 3MB');
                                        return;
                                    }

                                    const formData = new FormData();
                                    formData.append('files', file);
                                    formData.append('business_id', businessid);

                                    formik.setFieldValue('businesslogo', file);

                                    fileUpload(formData);
                                }
                            }}
                            onBlur={() => formik.setFieldTouched('businesslogo', true)}
                            name='businesslogo'
                            error={formik.touched.businesslogo && Boolean(formik.errors.businesslogo)}
                            inputProps={{
                                accept: 'image/png, image/jpeg, application/pdf'
                            }}
                        />

                        {formik.touched.businesslogo && formik.errors.businesslogo && (
                            <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                {formik.errors.businesslogo}
                            </Typography>
                        )}
                    </Grid>
                    {loanNumberType === 'general' && (
                        <Grid item xs={12} sm={4} md={4}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                }}
                            >
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        format='dd/MM/yyyy'
                                        label='Previous Loan Date Range From'
                                        value={formik.values.previousloandaterangefrom}
                                        onChange={(newValue) => {
                                            setLoanStartDate(newValue);
                                            formik.setFieldValue('previousloandaterangefrom', newValue);
                                            if (
                                                newValue &&
                                                formik.values.previousloandaterangeto &&
                                                newValue > formik.values.previousloandaterangeto
                                            ) {
                                                formik.setFieldValue('previousloandaterangeto', null);
                                            }
                                        }}
                                        maxDate={subDays(new Date(), 1)}
                                        // renderInput={(params) => (
                                        //   <TextField
                                        //     {...params}
                                        //     fullWidth
                                        //     name="previousloandaterangefrom"
                                        //     onBlur={formik.handleBlur}
                                        //     error={
                                        //       formik.touched.previousloandaterangefrom &&
                                        //       Boolean(formik.errors.previousloandaterangefrom)
                                        //     }
                                        //     helperText={
                                        //       formik.touched.previousloandaterangefrom &&
                                        //       formik.errors.previousloandaterangefrom
                                        //     }
                                        //   />
                                        // )}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                name: 'previousloandaterangefrom',
                                                onBlur: formik.handleBlur,
                                                error:
                                                    formik.touched.previousloandaterangefrom &&
                                                    Boolean(formik.errors.previousloandaterangefrom)
                                                // helperText:
                                                //   formik.touched.previousloandaterangefrom &&
                                                //   formik.errors.previousloandaterangefrom,
                                            }
                                        }}
                                    />
                                    {formik.touched.previousloandaterangefrom &&
                                        formik.errors.previousloandaterangefrom && (
                                            <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                                {formik.errors.previousloandaterangefrom}
                                            </Typography>
                                        )}
                                </LocalizationProvider>
                            </Box>
                        </Grid>
                    )}

                    {loanStartDate && (
                        <>
                            <Grid item xs={12} sm={4} md={4}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%'
                                    }}
                                >
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            format='dd/MM/yyyy'
                                            label='Previous Loan Date Range To'
                                            value={formik.values.previousloandaterangeto}
                                            onChange={(newValue) => {
                                                formik.setFieldValue('previousloandaterangeto', newValue);
                                                formik.setFieldTouched('previousloandaterangeto', true, false);
                                            }}
                                            maxDate={subDays(new Date(), 1)}
                                            minDate={formik.values.previousloandaterangefrom}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    name='previousloandaterangeto'
                                                    // onBlur={formik.handleBlur}
                                                    onBlur={() => {
                                                        formik.setFieldTouched('previousloandaterangeto', true);
                                                        formik.validateField('previousloandaterangeto');
                                                    }}
                                                    error={
                                                        formik.touched.previousloandaterangeto &&
                                                        Boolean(formik.errors.previousloandaterangeto)
                                                    }
                                                    helperText={
                                                        formik.touched.previousloandaterangeto &&
                                                        formik.errors.previousloandaterangeto
                                                    }
                                                />
                                            )}
                                        />
                                        {formik.touched.previousloandaterangeto &&
                                            formik.errors.previousloandaterangeto && (
                                                <Typography sx={{ color: 'red', fontSize: '13px' }}>
                                                    {formik.errors.previousloandaterangeto}
                                                </Typography>
                                            )}
                                    </LocalizationProvider>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                <TextField
                                    label='Previous Loan Number From'
                                    name='previousloannumberfrom'
                                    value={formik.values.previousloannumberfrom}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    fullWidth
                                    error={
                                        formik.touched.previousloannumberfrom &&
                                        Boolean(formik.errors.previousloannumberfrom)
                                    }
                                    helperText={
                                        formik.touched.previousloannumberfrom && formik.errors.previousloannumberfrom
                                    }
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} md={4}>
                                <TextField
                                    label='Previous Loan Number To'
                                    name='previousloannumberto'
                                    value={formik.values.previousloannumberto}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    fullWidth
                                    error={
                                        formik.touched.previousloannumberto &&
                                        Boolean(formik.errors.previousloannumberto)
                                    }
                                    helperText={
                                        formik.touched.previousloannumberto && formik.errors.previousloannumberto
                                    }
                                    InputLabelProps={{ style: { transition: 'none' } }}
                                />
                            </Grid>
                        </>
                    )}

                    <Grid item xs={12} sm={4} md={4} style={{ position: 'relative' }}>
                        <Box
                            sx={{
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <TextField
                                label='Bill Print Font Colour'
                                name='billprint'
                                value={formik.values.billprint}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    handleColorChange(e);
                                    setUploadedImage(null);
                                    setSelectedImageIndex(null);
                                }}
                                onBlur={formik.handleBlur}
                                fullWidth
                                type='color'
                                error={formik.touched.billprint && Boolean(formik.errors.billprint)}
                                helperText={formik.touched.billprint && formik.errors.billprint}
                                disabled={false}
                                onClick={handleTogglePicker}
                                InputLabelProps={{ shrink: true }}
                            />
                            {!showPicker && (
                                <IconButton
                                    onClick={handleTogglePicker}
                                    sx={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        zIndex: '5',
                                        color: '#fff'
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Bill Type</InputLabel>
                            <Select
                                label='Bill Type'
                                value={formik.values.billtype}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name='billtype'
                                error={formik.touched.billtype && Boolean(formik.errors.billtype)}
                            >
                                <MenuItem value='general'>Receipt Specimen - General (A4 - Split)</MenuItem>
                                <MenuItem value='customer_image'>
                                    Receipt Specimen - Customer Image (A4 - Split)
                                </MenuItem>
                                <MenuItem value='customer_with_item_image'>
                                    Receipt Specimen - Customer & Jewel Image (A4 - Split)
                                </MenuItem>
                                <MenuItem value='customer_with_item_image_article_type1'>
                                    Receipt Specimen - Customer & Jewel Image (A4 - Article Continuous Type 1)
                                </MenuItem>
                                <MenuItem value='customer_with_item_image_article_type2'>
                                    Receipt Specimen - Customer & Jewel Image (A4 - Article Continuous Type 2)
                                </MenuItem>
                            </Select>
                            {formik.touched.billtype && formik.errors.billtype && (
                                <Typography color='error'>{formik.errors.billtype}</Typography>
                            )}
                        </FormControl>
                    </Grid>

                    {formik?.values?.billprint && (
                        <Grid item xs={12}>
                            <Typography variant='subtitle2'>Bill Header (Image)</Typography>
                            <Grid
                                container
                                spacing={1}
                                alignItems='center'
                                sx={{ flexWrap: 'nowrap', overflowX: 'auto' }}
                            >
                                {imagePreviews.map((image, index) => (
                                    <Grid item key={index}>
                                        <Card
                                            style={{
                                                cursor: 'pointer',
                                                width: 100,
                                                height: 100,
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                            onClick={() => handleImageClick(index)}
                                        >
                                            <CardMedia
                                                component='img'
                                                height='100'
                                                image={image.url}
                                                alt='Image'
                                                style={{ objectFit: 'cover' }}
                                            />
                                            {selectedImageIndex === index && (
                                                <Box
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                        background: 'rgba(0, 0, 0, 0.5)',
                                                        padding: '5px'
                                                    }}
                                                >
                                                    <CheckCircleIcon style={{ color: 'white' }} />
                                                </Box>
                                            )}
                                        </Card>
                                    </Grid>
                                ))}

                                <Grid item>
                                    <Card
                                        sx={{
                                            cursor: 'pointer',
                                            width: 100,
                                            height: 100,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '1px dashed gray',
                                            position: 'relative'
                                        }}
                                    >
                                        <input
                                            ref={fileInputRef}
                                            type='file'
                                            accept='image/png'
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                opacity: 0
                                            }}
                                            onChange={(event) => {
                                                const fileInput = event.currentTarget;
                                                const file = fileInput.files[0];

                                                if (file && file.type === 'image/png') {
                                                    const formData = new FormData();
                                                    formData.append('files', file);
                                                    formData.append('business_id', businessid);
                                                    fileUploadBill(formData);

                                                    setFileName(file.name);

                                                    const uploadedImageUrl = URL.createObjectURL(file);

                                                    handleFileCustomChange(event);

                                                    formik.setFieldValue('headerimage', uploadedImageUrl);
                                                    fileInput.value = '';
                                                }
                                            }}
                                        />

                                        <IconButton color='primary' onClick={handleIconClick}>
                                            <AddIcon />
                                        </IconButton>
                                    </Card>
                                </Grid>

                                {uploadedImage && (
                                    <>
                                        <Card
                                            sx={{
                                                width: 100,
                                                height: 100,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                        >
                                            <CardMedia
                                                component='img'
                                                image={uploadedImage}
                                                alt='Uploaded Image'
                                                sx={{
                                                    objectFit: 'cover',
                                                    width: '100%',
                                                    height: '100%'
                                                }}
                                            />
                                        </Card>
                                    </>
                                )}
                            </Grid>

                            {formik.touched.headerimage && formik.errors.headerimage && (
                                <Typography color='error'>{formik.errors.headerimage}</Typography>
                            )}
                        </Grid>
                    )}
                    <Grid container item>
                        <Grid item xs={12} sm={12} md={9} lg={9} my={'auto'}>
                            <Typography>
                                Do you want to enable a common item prefix for pledged items in the Loan Receipt?
                            </Typography>
                        </Grid>
                        <Grid item xs={6} sm={2} md={1} lg={1} my={'auto'}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.isGoldItemPrefix}
                                        onChange={(e) => {
                                            formik.setFieldValue('isGoldItemPrefix', e.target.checked);
                                        }}
                                        name='isGoldItemPrefix'
                                    />
                                }
                                labelPlacement='end'
                                label={
                                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '11px', lg: '13.7px' } }}>
                                        Gold
                                    </Typography>
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sm={2} md={1} lg={1} my={'auto'}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={formik.values.isSilverItemPrefix}
                                        onChange={(e) => {
                                            formik.setFieldValue('isSilverItemPrefix', e.target.checked);
                                        }}
                                        name='isSilverItemPrefix'
                                    />
                                }
                                labelPlacement='end'
                                label={
                                    <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '11px', lg: '13.7px' } }}>
                                        Silver
                                    </Typography>
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} my={'auto'}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={formik.values.isBacksideTableAllowed}
                                    onChange={(e) => {
                                        formik.setFieldValue('isBacksideTableAllowed', e.target.checked);
                                    }}
                                    name='isBacksideTableAllowed'
                                />
                            }
                            labelPlacement='end'
                            label={<Typography>Do you want to inser table in back print ?</Typography>}
                        />
                    </Grid>

                    <Grid container spacing={2} justifyContent='flex-end'>
                        {/* <Grid item>
              <Button
                onClick={() => {
                  handleOpen();
                }}
                variant="contained"
                className={classes.animatedButton}
                sx={{ mt: 1, mr: 1 }}
                disabled={!isFormValid()}
              >
                Front Side Preview
              </Button>
            </Grid> */}
                        {/* <BillPreviewFront
                            open={licensePrintModal}
                            onClose={handleClose}
                            modalClose={onClose}
                            color={textColorStyle}
                            businessuuid={businessuuid}
                            tempImg={tempImg}
                            firstCanvasRef={firstCanvasRef}
                            license={license}
                            secondCanvasRef={secondCanvasRef}
                            setLanguage={setLanguage}
                            language={language}
                            setLicensePrintModalBack={setLicensePrintModalBack}
                            businesssid={businesssid}
                            licenseuuid={licenseuuid}
                            setLicenseUuid={setLicenseUuid}
                        />
                        <BillPreviewBack
                            open={licensePrintModalBack}
                            onClose={handleBackClose}
                            openFront={handleOpenFront}
                            onCloseFront={onClose}
                            openModal={open}
                            textColorStyle={textColorStyle}
                            businessuuid={businessuuid}
                            tempImg={tempImg}
                            firstCanvasRef={firstCanvasRef}
                            license={license}
                            secondCanvasRef={secondCanvasRef}
                            setLanguage={setLanguage}
                            language={language}
                            businesssid={businesssid}
                            setLicensePrintModalBack={setLicensePrintModalBack}
                            licenseuuid={licenseuuid}
                            setLicenseUuid={setLicenseUuid}
                            getLicensebusinessId={getLicensebusinessId}
                        /> */}

                        <EditBill
                            open={licensePrintModal}
                            onClose={handleClose}
                            // side={side}
                            licenceUid={billLicenceID}
                            paperType={paperbillType}
                            // preview={preview}
                            // color={color}
                            // uploadedImage={uploadedImage}
                            // firstCanvasRef={firstCanvasRef}
                            // secondCanvasRef={secondCanvasRef}
                            // license={license}
                            // businessuuid={businessuuid}
                            // licenseuuid={licenseuuid}
                            // setLicenseUuid={setLicenseUuid}
                            // businesssid={deatils}
                            // language={language}
                            // setLanguage={setLanguage}
                            // edit={editableIndex === index}
                            // setLanguageType={setLanguageType}
                            // languageType={languageType}
                        />

                        <Grid item>
                            <Button
                                variant='contained'
                                className={classes.animatedButton}
                                sx={{ mt: 1 }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
};

export default LicenseModal;
